export default {
  actions: {
    SetThemeAct: function ({ commit }, chosenTheme) {
      commit('SetThemeMut', chosenTheme);
    }
  },
  mutations: {
    SetThemeMut (state, theme) {
      state.Theme = theme;
    }
  },
  state: {
    Theme: 'dark'
  },
  getters: {
    ThemeGet (state) {
      return state.Theme;
    }
  }
}
